import { render, staticRenderFns } from "./hbPage.vue?vue&type=template&id=ff4ea44c&scoped=true&"
import script from "./hbPage.vue?vue&type=script&lang=js&"
export * from "./hbPage.vue?vue&type=script&lang=js&"
import style0 from "./hbPage.vue?vue&type=style&index=0&id=ff4ea44c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4ea44c",
  null
  
)

export default component.exports